import React, { useEffect, useState } from "react";

import Form from "@Components/Form";
import {
  URLS,
  REMARKS_URL,
  HARI_TERABAI_DAY_URL,
  ESTATE_FETCH_URL,
  DIVISION_FETCH_URL,
  BLOCK_FETCH_URL,
} from "configs/constants";
import eightAxios from "configs/axiosConfig";
import { useNotifyContext } from "@Components/Notify";
import { useParams, useHistory } from "react-router-dom";
import LoadingIcon from "@Components/LoadingIcon/LoadingIcon";
import ConfirmDialog from "@Components/ConfirmDialog";

const today = new Date();

const initialValues = {
  name: "",
  date:
    today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate(),
  estate: "",
  division: "",
  block: "",
  type_of_attendance_present: 20005,
};

const HariTerabaiDayForm = () => {
  const history = useHistory();
  const params = useParams();
  const [presentAttendanceType, setPresentAttendanceType] = useState([]);
  const [loading, setLoading] = useState(false);
  const [disableDivision, setDisableDivision] = useState(true);
  const [disableBlock, setDisableBlock] = useState(true);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const setNotify = useNotifyContext();

  const mapAttendanceTypes = (types) => {
    let tempTypes = [];
    let cnt = 0;
    types.forEach((attendanceType) => {
      console.log("data: " + attendanceType["id"]);
      tempTypes[cnt] = {
        id: attendanceType["id"],
        name: attendanceType["name"],
      };
      cnt++;
    });
    setPresentAttendanceType(tempTypes);
  };
  
  const getEstateValues = (e,setDisableDivision) => {
    if (!e || e.length === 0) {
      setDisableDivision(true);
    }
    else {
      setDisableDivision(false);
    }
    
  };
  const getDivisonValues = (e,setDisableBlock) => {
    if (!e || e.length === 0) {
      setDisableBlock(true);
    }
    else {
      setDisableBlock(false);
    }
    
  };


  useEffect(() => {
    setLoading(true);
    eightAxios
      .get(REMARKS_URL + "?status=Present&type=hari_terabai")
      .then((response) => {
        if (response.status === 200) {
          console.log(response.data);
          if (response.data.results) {
            console.log(response.data.results);
            mapAttendanceTypes(response.data.results);
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response);
        }
        setLoading(false);
      });
  }, []);

  const handleSubmit = (values, { setSubmitting }) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: true,
      title: "ARE YOU SURE YOU WANT TO SAVE THIS?",
      subTitle: "YOU CANNOT UNDO THIS OPERATION.",
      onConfirm: () => {
        if (values.id === undefined) {
          eightAxios
            .post(HARI_TERABAI_DAY_URL, values)
            .then(() => {
              history.push(URLS.NON_WORKING_DAY_HARI_TERABAI);
            })
            .catch((error) => {
              setNotify({
                isOpen: true,
                message: error.response.data.message,
                type: "error",
              });
              setConfirmDialog({ ...confirmDialog, isOpen: false });
              setSubmitting(false);
            });
        } else {
          eightAxios
            .patch(`${HARI_TERABAI_DAY_URL}${params.id}/`, values)
            .then(() => {
              history.push(URLS.NON_WORKING_DAY_HARI_TERABAI);
            })
            .catch((error) => {
              setNotify({
                isOpen: true,
                message: error.response.data.message,
                type: "error",
              });
              setConfirmDialog({ ...confirmDialog, isOpen: false });
              setSubmitting(false);
            });
        }
      },
    });
  };

  const formFields = [
    {
      type: "datepicker",
      name: "date",
      autoComplete: "off",
      size: "small",
      label: "Date",
      required: true,
    },
    {
      type: "reactselect",
      name: "estate",
      label: "Estate",
      proxyUrl: ESTATE_FETCH_URL,
      required:true,
      paginated: true,
      getValue: (e) => getEstateValues(e, setDisableDivision),

    },
    {
      type: "reactselect",
      name: "division",
      label: "Division",
      proxyUrl: DIVISION_FETCH_URL,
      paginated: true,
      disabled:disableDivision,
      getValue: (e) => getDivisonValues(e, setDisableBlock),

      optionsDependsOn: "estate",
    },
    {
      type: "reactselect",
      name: "block",
      label: "Block",
      proxyUrl: BLOCK_FETCH_URL,
      paginated: true,
      disabled:disableBlock,

      optionsDependsOn: "division",
    },
    {
      type: "reactselect",
      name: "type_of_attendance_present",
      label: "Type of Attendance (Present)",
      required: true,
      outerOptions: presentAttendanceType,
      disabled: true,
    },
  ];

  const formButtons = ["save", "cancel"];

  if (loading) {
    return <LoadingIcon image text="Loading" />;
  }

  return (
    <div>
      <Form
        initialValues={initialValues}
        outerSubmitHandler={handleSubmit}
        submitUrl={HARI_TERABAI_DAY_URL}
        listRoute={URLS.NON_WORKING_DAY_HARI_TERABAI}
        formFields={formFields}
        formButtons={formButtons}
        formTitle="Hari Terabai"
      />
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
    </div>
  );
};

export default HariTerabaiDayForm;
